import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";

import { footerComponentsMap } from "../blocks/componentMaps";
import { OffersPageBody } from "../components/OffersPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

const OffersPageFinePrint = (
    props: Immutable<{ page: templates.OffersPageTemplate["page"] }>,
): React.JSX.Element | null => {
    if (!props.page.fine_print) {
        return null;
    }
    return (
        <>
            {props.page.fine_print.value.map((block) => (
                <StreamField
                    key={block.id}
                    tagName="div"
                    attrs={{
                        className: `w-block-${block.type} block-${block.type}`,
                    }}
                    value={[block]}
                    components={footerComponentsMap}
                />
            ))}
        </>
    );
};

export const Template = (
    props: Immutable<templates.OffersPageTemplate>,
): React.JSX.Element => (
    <PageSkeleton
        pageChrome={props.page_chrome}
        afterFooter={<OffersPageFinePrint page={props.page} />}
    >
        <OffersPageBody {...props} />
    </PageSkeleton>
);
